import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@pulsex/utils";
import { EmblaCarouselType } from "embla-carousel";
import React from "react";

const CarouselArrows = ({ emblaApi }: { emblaApi: EmblaCarouselType }) => {
  return (
    <>
      <button
        className={cn(
          "group block z-20 bg-gray-100 py-1 px-2.5 rounded absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 mr-2 transition-all duration-300 hover:bg-blue cursor-pointer",
          !emblaApi?.canScrollPrev() && "opacity-50 cursor-not-allowed",
          "lg:text-sm lg:px-2 lg:py-0.5"
        )}
        onClick={() => emblaApi?.canScrollPrev() && emblaApi?.scrollPrev()}
      >
        <FontAwesomeIcon
          icon={faAngleLeft}
          className="text-blue group-hover:text-white"
        />
      </button>
      <button
        className={cn(
          "group block z-20 bg-gray-100 py-1 px-2.5 rounded absolute right-0 top-1/2 translate-x-1/2 -translate-y-1/2 ml-2 transition-all duration-300 hover:bg-blue cursor-pointer",
          !emblaApi?.canScrollNext() &&
            "opacity-50 cursor-not-allowed text-cyan-300",
          "lg:text-sm lg:px-2 lg:py-0.5"
        )}
        onClick={() => emblaApi?.canScrollNext() && emblaApi?.scrollNext()}
      >
        <FontAwesomeIcon
          icon={faAngleRight}
          className="text-blue group-hover:text-white"
        />
      </button>
    </>
  );
};

export default CarouselArrows;
